<div id="cl-wrapper" class="login-container login-theme">

  <div class="login-columns width-450">

    <div class="login-form">
      <div class="block-flat">
        <div class="header">
          <h3 class="text-center">
            <img [src]="logoUrl" alt="logo" class="img-responsive logo-img">
          </h3>
        </div>
        <div *ngIf="form">
          <form [formGroup]="form" class="form-horizontal" *ngIf="step === 1">
            <div class="content">

              <div class="hidePortalName">
                <h3 class="title text-center"><strong>{{PORTAL_NAME | translate}}</strong></h3>
              </div>
              <h4 class="title"><strong>{{'SET_PASSWORD_TITLE' | translate}}</strong></h4>

              <div class="alert alert-danger" *ngIf="formAllErrors.length > 0">
                <i class="fas fa-times-circle sign"></i>
                <strong>{{'ERROR'|translate}}:</strong> {{formAllErrors}}
              </div>

              <div class="form-group">
                <div class="col-sm-12">
                  <mat-form-field class="full-width">
                    <mat-label>{{'NEW_PASSWORD'|translate}}</mat-label>
                    <i matPrefix class="fas fa-lock"></i>
                    <input type="password" matInput formControlName="NewPassword">
                  </mat-form-field>
                  <mat-error *ngIf="formErrors.NewPassword"> {{ formErrors.NewPassword }}</mat-error>
                  <small class="text-muted" *ngIf="!formErrors.NewPassword && passwordHint">{{ passwordHint }}</small>
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-12">
                  <mat-form-field class="full-width">
                    <mat-label>{{'CONFIRM_NEW_PASSWORD'|translate}}</mat-label>
                    <i matPrefix class="fas fa-lock"></i>
                    <input type="password" matInput formControlName="ConfirmNewPassword">
                  </mat-form-field>
                  <mat-error *ngIf="formErrors.ConfirmNewPassword"> {{ formErrors.ConfirmNewPassword }}</mat-error>
                </div>
              </div>

              <!-- Botões -->
              <div class="form-group margin-bottom-30">
                <div class="col-sm-12">

                  <button type="button" class="btn pull-left no-margin-left" title="{{'LOGIN' | translate}}"
                    [routerLink]="['/login']">
                    <i class="fas fa-arrow-left"></i>&nbsp;{{'LOGIN' | translate}}
                  </button>

                  <button type="button" class="btn btn-primary pull-right" title="{{'SET_PASSWORD_BUTTON' | translate}}"
                    (click)="onSubmit()" [disabled]="!form.valid">
                    <i class="fas fa-key"></i>&nbsp;{{'SET_PASSWORD_BUTTON' | translate}}
                  </button>

                </div>
              </div>
              <!-- Email de suporte -->
              <div class="form-group margin-bottom-30" *ngIf="SUPPORT_EMAIL">
                <div class="col-sm-12 text-center">
                  <a class="color-default" [href]="SUPPORT_EMAIL"
                    target="_blank"><strong>{{'WANT_TO_ACCESS_SUPPORT'|translate}}</strong></a>
                </div>
              </div>

            </div>
            <div class="foot">
              <div class="text-center">
                <a class="color-default small" [href]="loginFooterUrl" target="_blank"
                  [innerHtml]="loginFooterText"></a>
              </div>
            </div>
          </form>
        </div>

        <div class="form-horizontal" *ngIf="step > 1">
          <div class="content">
            <div class="hidePortalName">
              <h3 class="title text-center"><strong>{{PORTAL_NAME | translate}}</strong></h3>
            </div>
            <h4 class="title"><strong>{{'SET_PASSWORD_TITLE' | translate}}</strong></h4>

            <p [innerHTML]="message | translate" *ngIf="step === 2 || step === 3"></p>

            <!-- Botões -->
            <div class="form-group margin-bottom-30">
              <div class="col-sm-12">

                <button type="button" class="btn pull-left no-margin-left margin-top-10" title="{{'LOGIN' | translate}}"
                  [routerLink]="['/login']">
                  <i class="fas fa-arrow-left"></i>&nbsp;{{'LOGIN' | translate}}
                </button>

              </div>
            </div>
            <!-- Email de suporte -->
            <div class="form-group margin-bottom-30" *ngIf="SUPPORT_EMAIL">
              <div class="col-sm-12 text-center">
                <a class="color-default" [href]="SUPPORT_EMAIL"
                  target="_blank"><strong>{{'WANT_TO_ACCESS_SUPPORT'|translate}}</strong></a>
              </div>
            </div>

          </div>
          <div class="foot">
            <div class="text-center">
              <a class="color-default small" [href]="loginFooterUrl" target="_blank" [innerHtml]="loginFooterText"></a>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>

</div>
